import React from 'react';
import * as Styled from './DownloadLogo.styled';
import { ButtonSizes } from '@Utils/shared/components/Button-v3';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';

interface OwnProps {
  isActionDisabled: boolean;
}

const DownloadLogo: React.FC<OwnProps> = ({ isActionDisabled = true }) => {
  const logoMakerThankYouWidget = useWidget(WidgetId.LogoMakerThankYouRaidIdV3);

  return (
    <Styled.Wrapper>
      <Styled.ButtonLogo size={ButtonSizes.small} disabled={isActionDisabled}>
        {logoMakerThankYouWidget.strings.downloadLogo}
      </Styled.ButtonLogo>
    </Styled.Wrapper>
  );
};

export default DownloadLogo;
